import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { Router } from '@angular/router';

export type DesktopHeaderSection = 'health-assistant' | 'my-data' | 'settings';

@Component({
  selector: 'app-desktop-header',
  standalone: true,
  imports: [NgClass],
  templateUrl: './desktop-header.component.html'
})
export class DesktopHeaderComponent {
  @Input() active: DesktopHeaderSection | null = 'health-assistant';
  @Output() sectionSelect = new EventEmitter<DesktopHeaderSection>();

  constructor(private router: Router) {}

  select(section: DesktopHeaderSection) {
    if (section === this.active) {
      return;
    }
    // My data is its own route, so the header navigates there directly
    if (section === 'my-data') {
      this.router.navigate(['/report/BCRA']);
      return;
    }
    this.sectionSelect.emit(section);
  }
}
